import { useTranslation } from 'react-i18next';

import { ConsignmentNumberFilter } from '@/features/dashboard-filters';
import { DateRangePicker, type DateRangeValue } from '@/shared/ui/date-range-picker';

import type { ReceiveLossesUrlState } from '../model/types';

interface ReceiveLossesFiltersProps {
  filters: ReceiveLossesUrlState;
  onFilterChange: (key: keyof ReceiveLossesUrlState, value: string) => void;
  onDateRangeChange: (dateFrom: string, dateTo: string) => void;
}

/**
 * Lost or Not Sent Items filter popover content: consignment number (LIKE) +
 * actual-date-of-receipt range. Reuses the shared field components used by the
 * consignments / receive-history filter bars.
 */
export function ReceiveLossesFilters({ filters, onFilterChange, onDateRangeChange }: ReceiveLossesFiltersProps) {
  const { t } = useTranslation();

  const handleDateRangeChange = (value: DateRangeValue) => {
    onDateRangeChange(value.fromDate || '', value.toDate || '');
  };

  return (
    <div className="flex flex-wrap items-start gap-4">
      <ConsignmentNumberFilter
        value={filters.consignmentNumber}
        onChange={(value) => onFilterChange('consignmentNumber', value)}
      />

      <DateRangePicker
        key={`${filters.dateFrom}|${filters.dateTo}`}
        label={t('receive.receivedate.label', 'Actual Date of Receipt')}
        defaultPreset="CR"
        defaultFromDate={filters.dateFrom || undefined}
        defaultToDate={filters.dateTo || undefined}
        onChange={handleDateRangeChange}
      />
    </div>
  );
}
